import type { NavigateFunction } from 'react-router-dom';

export interface DrillCrumb {
    path: string;
    label: string;
}

interface RouterHistoryState {
    idx?: number;
    key?: string;
    usr?: unknown;
}

const historyIndex = (): number => {
    const state = window.history.state as RouterHistoryState | null;
    return typeof state?.idx === 'number' ? state.idx : 0;
};

export const canPopHistory = (): boolean => historyIndex() > 0;

export const stampHistoryState = (patch: Record<string, unknown>): void => {
    const state = window.history.state as RouterHistoryState | null;
    if (!state) {
        return;
    }

    const usr =
        state.usr && typeof state.usr === 'object'
            ? (state.usr as Record<string, unknown>)
            : {};

    window.history.replaceState(
        {
            ...state,
            usr: {
                ...usr,
                ...patch,
            },
        },
        '',
    );
};

export const getLastDrillCrumbLabel = (
    trail: DrillCrumb[] | undefined,
    fallback: string,
): string => {
    return trail?.[trail.length - 1]?.label ?? fallback;
};

export const withDrillTrail = <T>(
    current: { trail?: DrillCrumb[] } | undefined,
    crumb: DrillCrumb,
    next: T,
): T & { trail: DrillCrumb[] } => ({
    ...next,
    trail: [...(current?.trail ?? []), crumb],
});

export const popDrillHistory = (
    navigate: NavigateFunction,
    trail: DrillCrumb[] | undefined,
    fallback: () => void,
): void => {
    if (trail?.length && canPopHistory()) {
        navigate(-1);
        return;
    }

    fallback();
};

export const popDrillToCrumb = (
    navigate: NavigateFunction,
    trail: DrillCrumb[],
    index: number,
    fallback: () => void,
): void => {
    const stepsBack = trail.length - index;
    if (stepsBack > 0 && historyIndex() >= stepsBack) {
        navigate(-stepsBack);
        return;
    }

    fallback();
};
